"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../../../commons/Constants");
const global_1 = require("../../../commons/global");
const Cesium = window.Cesium;
class EntityHelperServiceV2 {
    constructor(viewer) {
        this.viewer = viewer;
        // for debugging
        this.debug = Constants_1.Constants.debug_off;
        this.debugStyle = 'color:#fff;background-color:#941;';
        // all entities
        this.entities = null;
        // any entity's properties / references
        this.entity_properties = null;
        this.callers = {};
        this.annot_shape_ref = {};
        // our subscriptions
        this._subs = [];
        // fresh maps for everyone!
        this.entities = new Map();
        this.entity_properties = new Map();
    }
    init() {
        // return 'Hello, world!';
    }
    // this components various subscriptions to events
    addSubscription(f) {
        this._subs.push(f);
    }
    // delete all of them
    deleteSubscriptions() {
        this._subs.forEach(annotation => annotation.unsubscribe());
    }
    // default destroyer just calls the deleteSubscriptions. If you provide your own, 
    // remember to call deleteSubscriptions() yourself or call super
    ngOnDestroy() {
        this.deleteSubscriptions();
    }
    setCesiumViewer(viewer = null) {
        // console.log ( '%c entityHelper :: setting Cesium viewer ---------------------------', this.debugStyle );
        this.viewer = viewer;
    }
    getEntity(id) {
        let test = this.entities.get(id);
        if (test) {
            return test;
        }
        return null;
    }
    getEntityProperties(id) {
        let test = this.entity_properties.get(id);
        if (test) {
            return test;
        }
        return null;
    }
    setEntityProperties(id, props) {
        let test = this.entity_properties.get(id);
        if (test) {
            this.entity_properties.set(id, props);
        }
    }
    getEntityId(aid, shape) {
        let ret = null;
        if (this.annot_shape_ref[aid]) {
            if (isNaN(this.annot_shape_ref[aid][shape])) {
                ret = this.annot_shape_ref[aid][shape];
            }
        }
        // console.log ( 'entity : getEntityId('+aid+', '+shape+')', aid, ret, this.annot_shape_ref );  
        return ret;
    }
    setEntityId(aid, shape, eid) {
        if (!this.annot_shape_ref[aid]) {
            this.annot_shape_ref[aid] = {};
        }
        this.annot_shape_ref[aid][shape] = eid;
        // console.log ( 'entity : setEntityId('+aid+', '+shape+', '+eid+')', this.annot_shape_ref[aid][shape], this.annot_shape_ref );
    }
    updateEntityId(aid, shape, eid) {
        if (this.annot_shape_ref[aid] && this.annot_shape_ref[aid][shape]) {
            this.annot_shape_ref[aid][shape] = eid;
        }
    }
    deleteEntityId(aid, shape) {
        if (this.annot_shape_ref[aid] && this.annot_shape_ref[aid][shape]) {
            delete this.annot_shape_ref[aid][shape];
        }
    }
    createEntityName(type, info, shape = null, point = null) {
        const name = info ? (info['name'] ? (info.name + (info.id ? ' (' + info.id + ')' : '')) : info) : '';
        let ret = type.toUpperCase() + ':  info=[ ' + name + ' ]';
        if (shape != null) {
            ret = ret + ', shape=' + shape;
        }
        if (point != null) {
            ret = ret + ', point=' + point;
        }
        return ret;
    }
    addEntity(type, props, a, callerId = null) {
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        let ref = {
            typeRef: type,
            annotationRef: annotationRef,
            entityRef: props.hasOwnProperty('entityRef') ? props.entityRef : null,
            shapeRef: props.hasOwnProperty('shapeRef') ? props.shapeRef : null,
            pointRef: props.hasOwnProperty('pointRef') ? props.pointRef : null
        };
        let config = this.getEntityConfig(type, props, a);
        config['name'] = this.createEntityName(type, a, ref.shapeRef, ref.pointRef);
        // try to make an entity
        let _obj = this.viewer.entities.add(config);
        // console.log ( '%c entityHelper :: addEntity()', this.debugStyle, props, ref, config, _obj );
        // success
        if (_obj) {
            this.entities.set(_obj.id, _obj);
            this.entity_properties.set(_obj.id, ref);
            // if there's an annotation
            if (a && type !== 'handle' && type !== 'deletehandle' && type !== 'addhandle' && type !== 'ghostline') {
                if (!this.annot_shape_ref[annotationRef]) {
                    this.annot_shape_ref[annotationRef] = {};
                }
                this.annot_shape_ref[annotationRef][ref.shapeRef] = _obj.id;
            }
            // register who's called in?
            if (callerId) {
                if (!this.callers[callerId]) {
                    this.callers[callerId] = {};
                }
                this.callers[callerId][_obj.id] = ref;
            }
            return _obj.id;
        }
        // fail
        return null;
    }
    // only used for new Annotations which changes some references from 0 to their actual id when saved, so we need to update the references
    changeShapesAnnotationRef(a) {
        let annotationRef = a ? (a['id'] ? a['id'] : 0) : null;
        console.log('%c changeShapeRefs', Constants_1.Constants._red, annotationRef, a['shapes']);
        if (a['shapes']) {
            // console.log ( '%c changeShapeRefs', Constants._red, a['shapes'], this.callers );
            let shapes = a['shapes'];
            for (let n = 0; n < shapes.length; n++) {
                let shape = shapes[n];
                let e = null;
                if (e = this.getEntityId(0, n)) {
                    this.setEntityId(annotationRef, n, e);
                }
                console.log('%c changeShapeRefs -', Constants_1.Constants._red, e, annotationRef);
                a['shapes'][n].annotationRef = annotationRef;
                if (this.callers['measure-helper-0']) {
                    delete this.callers['measure-helper-0'];
                }
                this.callers['measure-helper-' + annotationRef] = shape.entityRef;
                let p = this.getEntityProperties(shape.entityRef);
                // console.log ( '%c changeShapeRefs --', Constants._red, p );
                p.annotationRef = annotationRef;
                p.entityRef = shape.entityRef;
                this.setEntityProperties(shape.entityRef, p);
                console.log('%c changeShapeRefs ----', Constants_1.Constants._red, this.getEntityProperties(shape.entityRef));
            }
            console.log('%c changeShapeRefs END', Constants_1.Constants._red, a['shapes'], this.callers);
        }
    }
    showHideEntity(a, show = true) {
        if (a['shapes']) {
            let shapes = a['shapes'];
            for (let n = 0; n < shapes.length; n++) {
                let shape = shapes[n];
                this.entityChange('show', shape['entityRef'], show);
            }
        }
    }
    destroyEntity(id) {
        if (this.entities.get(id)) {
            // console.log ( '%c entityHelper :: destroyEntity() DELETING', this.debugStyle, id, this.entities.get ( id ) );
            // remove them from the map
            this.viewer.entities.remove(this.entities.get(id));
            this.entities.delete(id);
        }
        else {
            // console.log ( '%c entityHelper :: destroyEntity() FAILED', this.debugStyle, id, this.entities );
        }
    }
    destroyEntitiesByCaller(callerId) {
        let a = this.callers[callerId];
        if (this.debug) {
            console.log('%c entityHelper :: destroyEntitiesByCaller(' + callerId + ')', this.debugStyle, a);
        }
        if (a) {
            for (var item in a) {
                if (a.hasOwnProperty(item)) {
                    this.destroyEntity(item);
                }
            }
            delete this.callers[callerId];
        }
    }
    // entity modifiers
    entityChange(what, id, value) {
        let e = this.getEntity(id);
        if (e) {
            switch (e.type) {
                case global_1.AnnotationType.line:
                    if (what == 'color') {
                        e.polyline.material.color = Cesium.Color.fromCssColorString(value);
                        e.polyline.depthFailMaterial.color = Cesium.Color.fromCssColorString(value).withAlpha(0.2);
                        e.polyline.depthFailMaterial.outlineColor = Cesium.Color.fromCssColorString(value);
                    }
                    else if (what == 'show') {
                        e.show = value;
                    }
                    else if (what == 'lineWidth') {
                        e.polyline.width = value;
                    }
                    else if (what == 'coords') {
                        e.polyline.positions = value;
                    }
                    else if (what == 'clamping') {
                        e.polyline.clampToGround = value;
                        e.polyline.perPositionHeight = !value;
                    }
                    break;
                case global_1.AnnotationType.area:
                case global_1.AnnotationType.volume:
                    if (what == 'coords') {
                        // console.log ( '%c debug =', Constants._red,  what, id, value );
                        e.polygon.hierarchy = new Cesium.ConstantProperty(new Cesium.PolygonHierarchy(value));
                        // e.polygon.hierarchy = value;
                    }
                    else if (what == 'show') {
                        e.show = value;
                    }
                    else if (what == 'color') {
                        e.polygon.material.color = Cesium.Color.fromCssColorString(value);
                    }
                    else if (what == 'lineWidth') {
                        e.polygon.width = value;
                    }
                    else if (what == 'clamping') {
                        e.polygon.clampToGround = value;
                        e.polygon.perPositionHeight = !value;
                    }
                    break;
            }
        }
    }
    setEntityProperty(what, id, value) {
        this.entityChange(what, id, value);
    }
    getEntityProperty(what, id) {
        let e = this.getEntity(id);
        if (e) {
            switch (e.type) {
                case global_1.AnnotationType.line:
                    if (what == 'color') {
                        return e.polyline.material.color;
                    }
                    else if (what == 'lineWidth') {
                        return e.polyline.width;
                    }
                    else if (what == 'coords') {
                        // console.log ( '%c debug .', Constants._red, e.polyline, e.polyline.positions, e.polyline._positions )
                        // console.log ( '%c debug _', Constants._red, e._polyline, e._polyline.positions, e._polyline._positions )
                        return e.polyline.positions;
                    }
                    else if (what == 'clamping') {
                        return e.polyline.clampToGround;
                    }
                    break;
                case global_1.AnnotationType.area:
                case global_1.AnnotationType.volume:
                    if (what == 'coords') {
                        return e.polygon.hierarchy;
                    }
                    else if (what == 'color') {
                        return e.polygon.material.color;
                    }
                    else if (what == 'lineWidth') {
                        return e.polygon.width;
                    }
                    else if (what == 'clamping') {
                        return e.polygon.clampToGround;
                    }
                    break;
            }
        }
        return null;
    }
    getEntityConfig(type, props, annotation = null) {
        // base config for shapes
        switch (type) {
            case global_1.AnnotationType.handle:
                return {
                    type: type,
                    position: props.coord,
                    point: {
                        pixelSize: global_1.AnnotationStyle.dotSize,
                        color: global_1.AnnotationStyle.dotColor,
                        disableDepthTestDistance: 30.0,
                        outlineWidth: global_1.AnnotationStyle.dotOutlineSize,
                        outlineColor: global_1.AnnotationStyle.dotOutlineColor,
                        eyeOffset: new Cesium.Cartesian3(0, 0, -1),
                    },
                };
            case global_1.AnnotationType.addhandle:
                return {
                    type: type,
                    position: props.coord,
                    billboard: {
                        image: 'assets/images/icons/add.png',
                        // pixelOffset : new Cesium.Cartesian2(-70, -40),
                        color: Cesium.Color.WHITE.withAlpha(0.9),
                        disableDepthTestDistance: 30,
                        width: 14, height: 14
                    },
                    label: {
                        text: '',
                        font: '12px sans-serif',
                        pixelOffset: new Cesium.Cartesian2(-82, -42),
                        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                        verticalOrigin: Cesium.VerticalOrigin.TOP,
                        disableDepthTestDistance: Number.POSITIVE_INFINITY,
                        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(1, 500),
                        translucencyByDistance: new Cesium.NearFarScalar(1, 1.0, 1000, 0.0),
                    }
                };
            case global_1.AnnotationType.deletehandle:
                return {
                    type: type,
                    position: props.coord,
                    billboard: {
                        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                        image: 'assets/images/icons/del.png',
                        pixelOffset: new Cesium.Cartesian2(-60, -3),
                        disableDepthTestDistance: 30,
                        scale: 0.6
                    }
                };
            case global_1.AnnotationType.multipoi:
                return {
                    type: type,
                    position: props.coord,
                    point: {
                        pixelSize: 10,
                        color: Cesium.Color.WHITE
                    }
                };
            case global_1.AnnotationType.ghostline:
                return {
                    type: type,
                    polyline: {
                        positions: new Cesium.CallbackProperty(props.callback, false),
                        width: 6,
                        arcType: Cesium.ArcType.GEODESIC,
                        perPositionHeight: true,
                        classificationType: Cesium.ClassificationType.BOTH,
                        clampToGround: false,
                        material: new Cesium.PolylineDashMaterialProperty({
                            color: Cesium.Color.WHITE,
                            gapColor: Cesium.Color.WHITE.withAlpha(0.2),
                            dashLength: 4.0
                        }),
                        depthFailMaterial: new Cesium.PolylineOutlineMaterialProperty({
                            width: 0.2,
                            color: Cesium.Color.YELLOW.withAlpha(0.2),
                            outlineColor: Cesium.Color.YELLOW.withAlpha(0.3),
                            outlineWidth: 3
                        }),
                    }
                };
            case global_1.AnnotationType.line:
                let c = typeof props.color == 'string' ? props.color : 'yellow';
                // console.log ( '%c WEYUTQWEUYITQWUYETQWIUYEQRWEUQYWETQUIYWE', Constants._red, props, c);
                return {
                    type: type,
                    polyline: {
                        positions: props.positions,
                        width: props.lineWidth,
                        arcType: Cesium.ArcType.GEODESIC,
                        perPositionHeight: props.perPositionHeight,
                        classificationType: Cesium.ClassificationType.BOTH,
                        clampToGround: props.clampToGround,
                        material: new Cesium.PolylineOutlineMaterialProperty({
                            color: props.color,
                            outlineColor: Cesium.Color.LIGHTGREY.withAlpha(0.4),
                            outlineWidth: 2
                        }),
                        depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
                            color: props.color,
                            dashLength: 12,
                        }),
                    }
                };
            case global_1.AnnotationType.area:
            case global_1.AnnotationType.volume:
                return {
                    type: type,
                    polygon: {
                        hierarchy: props.positions,
                        outline: true,
                        outlineWidth: 2,
                        outlineColor: Cesium.Color.WHITE,
                        material: props.color,
                        perPositionHeight: props.perPositionHeight,
                        classificationType: Cesium.ClassificationType.BOTH,
                        clampToGround: props.clampToGround
                    }
                };
            case global_1.AnnotationType.volumepoint:
                return {
                    type: type,
                    position: props.coord,
                    point: {
                        pixelSize: 8,
                        color: Cesium.Color.WHITE.withAlpha(0.4)
                    }
                };
        }
        return {};
    }
}
exports.EntityHelperServiceV2 = EntityHelperServiceV2;
